module.exports = __webpack_public_path__ + "static/img/buddy_pictgrid38_920x858.f00452c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/buddy_pictgrid38_920x858.jpg
// module id = 8dYd
// module chunks = 0